import { pattern } from './pattern';

export const firstNameValidator = (value) => {
    if (!value || value.trim() === '') return false;
    return pattern.firstName.test(value.trim());
};

export const lastNameValidator = (value) => {
    if (!value || value.trim() === '') return false;
    return pattern.lastName.test(value.trim());
};
